/* Jurassic Bees: position the existing Judge.me slim review section inside
   HTML content using <div data-jb-review-banner></div>.
   Shopify editor page sections and product descriptions are both supported.
   This file moves the existing widget; it never duplicates reviews or stores customer data. */
(function () {
  'use strict';
  function positionReviewBanner() {
    var targets = document.querySelectorAll('[data-jb-review-banner]');
    if (!targets.length) return;
    // An explicit marker inside HTML always overrides the safe template fallback.
    var eligible = Array.prototype.filter.call(targets, function (el) {
      return !el.closest('.jb-slim-reviews__source');
    });
    var target = eligible.find(function (el) {
      return !el.hasAttribute('data-jb-review-fallback');
    }) || eligible[0];
    if (!target) return;
    var widget = document.querySelector('jb-slim-reviews.jb-slim-reviews');
    if (!widget) return;
    // Optional per-marker override. A marker without IDs uses that page or product's custom field.
    var explicitIds = target.getAttribute('data-jb-review-ids');
    if (explicitIds !== null) widget.setAttribute('data-jb-review-ids', explicitIds);
    if (target.contains(widget)) { if (typeof widget.collect === 'function') widget.collect(); return; }
    target.appendChild(widget);
    if (typeof widget.collect === 'function') widget.collect();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionReviewBanner, { once: true });
  } else {
    positionReviewBanner();
  }
  document.addEventListener('shopify:section:load', positionReviewBanner);
})();
